export const RESET_PASSWORD_REQUEST = 'AUTH/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST_PENDING = `${RESET_PASSWORD_REQUEST}_PENDING`;
export const RESET_PASSWORD_REQUEST_FULFILLED = `${RESET_PASSWORD_REQUEST}_FULFILLED`;
export const RESET_PASSWORD_REQUEST_REJECTED = `${RESET_PASSWORD_REQUEST}_REJECTED`;

export const requestPasswordReset = (email) => ({
  type: RESET_PASSWORD_REQUEST,
  email,
});

export const RESET = `${RESET_PASSWORD_REQUEST}_RESET`;

export const reset = () => ({
  type: RESET,
});
